import React, { FC } from 'react';

import SVGWrapper, { Svg } from './svg-wrapper';

const Tick: FC<Svg> = ({ color, width, height }: Svg) => (
  <SVGWrapper testId="tick-simple" width={width} height={height} viewBox="0 0 32 32">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.7361 9.32172C27.1107 9.72754 27.0854 10.3602 26.6796 10.7348L13.6796 22.7348C13.2852 23.0988 12.6738 23.0866 12.2942 22.7072L5.29296 15.7072C4.9024 15.3167 4.90234 14.6835 5.29283 14.293C5.68332 13.9024 6.31648 13.9023 6.70704 14.2928L13.0289 20.6136L25.323 9.2652C25.7288 8.89059 26.3615 8.9159 26.7361 9.32172Z"
      fill={color}
    />
  </SVGWrapper>
);

export default Tick;
